
import {Component, Vue, Prop} from 'vue-property-decorator';
import ApiService from '@/common/api.service';

@Component({})
export default class APIUserSettingsPage extends Vue {

  public userId: number = 0;
  public userName: string = '';
  public verificationsCount: number = 0;
  public verificationFormSubmitted: boolean = false;
  private dataLoading: boolean = true;
  private stats: any = { stats: {}, names: {}, namesRevert: {} };

  public async mounted() {
    this.userId = parseInt(this.$route.params.id, 10);
    const resp: any = await ApiService.query('/impact/api_key_client/' + this.userId);
    this.userName = resp.data.name;
    this.verificationsCount = resp.data.verifications_count;
    this.dataLoading = false;
    await this.getStats();
  }

  public async submitVerificationCount() {
    this.verificationFormSubmitted = true;
    await ApiService.put('/impact/api_key_client/' + this.userId,
        {id: this.userId, name: this.userName, verifications_count: this.verificationsCount});
    this.verificationFormSubmitted = false;
  }

  private async getStats() {
    const resp = await ApiService.query(`/impact/api_key_client/${this.userId}/get_verification_stats`);
    const statsKeys = Object.fromEntries(
      Object.entries(resp.data.names).map((item) => [item[1], item[0]])
    );
    this.stats = {
      names: resp.data.names,
      namesRevert: statsKeys,
      stats: resp.data.stats,
    }
  }

  get verificationsNames() {
    const names = Object.keys(this.stats.namesRevert);
    names.sort();
    return names;
  }

  get headers() {
    const dates = Object.keys(this.stats.stats);
    dates.sort().reverse();
    dates.unshift(this.$i18n.t('strings.verification') as string);
    return dates;
  }

  get statsRows() {
    const dates = Object.keys(this.stats.stats);
    dates.sort().reverse();
    const names = Object.keys(this.stats.namesRevert);
    names.sort();
    const tmp = names.map((verification: any) => {
      return [verification].concat(
        dates.map((verDate: any) => {
          if (this.stats.namesRevert[verification] && this.stats.stats[verDate][this.stats.namesRevert[verification]]) {
            return this.stats.stats[verDate][this.stats.namesRevert[verification]]; 
          } else {
            return 0;
          }
        })
      )
    });
    if (this.notFoundRow.length) {
      tmp.push(this.notFoundRow);
    }
    return tmp;
  }

  get notFoundRow() {
    const dates = Object.keys(this.stats.stats);
    dates.sort().reverse();
    let dirty = false;
    const tmp = dates.map((item: any) => {
      const notFound = Object.keys(this.stats.stats[item]).filter((key: any) => !this.stats.names[key]);
      if (notFound.length) {
        dirty = true;
        return notFound.map((key: any) => this.stats.stats[key]).reduce((acc: number, val: number) => acc + val);
      }
      return 0;
    });
    if (dirty) {
      tmp.unshift(this.$i18n.t('strings.unknownVerification'));
      return tmp;
    }
    return [];
  }
}
